<template>
  <div id="step-5-questionnaire">
    <questionnaire-component
      :questionnaire="questionnaire"
    />
  </div>
</template>

<script>
import QuestionnaireComponent from '../components/QuestionnaireComponent.vue';

export default {
  name: 'Step5Questionnaire',
  components: {
    QuestionnaireComponent,
  },
  data() {
    return {
      // TODO find a way to get these fields from a .json file or the drupal site.
      questionnaire: [
        {
          prompt:
            'Your purchase offer cannot be less than the listed price of the home.',
          type: 'singleChoice',
          options: ['True', 'False'],
          correctAnswer: 1,
          bottomHeaderTrue: 'Excellent job!',
          bottomHeaderFalse: 'Incorrect.',
          bottomText:
            'Your offer can be less than the listed price of the home. Your real estate agent can help you determine a reasonable offer.',
        },
        {
          prompt: 'Why is it important to get a home inspection before buying?',
          type: 'singleChoice',
          options: [
            'Reveals safety issues',
            'Could impact the offer amount and negotiations',
            'Reveals the overall health of the house',
            'All the above',
          ],
          correctAnswer: [0, 1, 2],
          bottomHeaderTrue: 'Great!',
          bottomHeaderFalse: 'Not quite.',
          bottomText:
            'A home inspection is important because it can reveal safety issues, impact the offer amount, and reveals the truth health of the house before you buy it.',
        },
        {
          prompt: 'A home appraisal is required before buying a house.',
          type: 'singleChoice',
          options: ['True', 'False'],
          correctAnswer: 0,
          bottomHeaderTrue: 'Awesome!',
          bottomHeaderFalse: 'Good try.',
          bottomText:
            'A home appraisal is required by a lender to establish a home’s value. This established value is used to calculate the amount of money that the lender will lend for the mortgage.',
        },
      ],
    };
  },
};
</script>

<style>
</style>
